import { ActionIcon, Input, TextInput } from "@marketplace/ui";
import clsx from "clsx";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { MdAddCircleOutline, MdDeleteSweep } from "react-icons/md";

import type { CrmProductFormSchema } from "../../hooks/schemas/use-crm-product-form-schema";

export const CrmProductAttributes = ({ isPending }: { isPending: boolean }) => {
  const { t } = useTranslation("product", {
    keyPrefix: "integrationProductListPage.crmModal"
  });

  const {
    watch,
    setValue,
    formState: { errors }
  } = useFormContext<CrmProductFormSchema>();

  const currentAttributes = watch("attributes") || [];

  return (
    <Input.Wrapper
      label={t("labels.attributes")}
      error={errors.attributes?.message}
    >
      <div className="flex flex-col gap-y-2">
        {currentAttributes.map((attr, index) => {
          return (
            <div
              className={clsx("flex flex-col gap-y-2", {
                "pl-6": currentAttributes.length > 0
              })}
              key={index}
            >
              <div className="relative">
                <div className="absolute w-6 h-full -left-7 flex items-center">
                  <ActionIcon
                    variant="subtle"
                    onClick={() => {
                      const newAttrs = [...currentAttributes];
                      newAttrs.splice(index, 1);
                      setValue("attributes", newAttrs, {
                        shouldDirty: true
                      });
                    }}
                    disabled={isPending}
                  >
                    <MdDeleteSweep className="h-4 w-4 text-[#FF0606]" />
                  </ActionIcon>
                </div>
                <div className="grid grid-cols-2 gap-x-2">
                  <TextInput
                    value={attr.key}
                    onChange={(e) => {
                      const newAttrs = [...currentAttributes];
                      newAttrs[index] = {
                        ...newAttrs[index],
                        key: e.target.value
                      };
                      setValue("attributes", newAttrs, {
                        shouldDirty: true
                      });
                    }}
                    size="lg"
                    placeholder={t("placeholders.attributeKey")}
                    disabled={isPending}
                  />
                  <TextInput
                    value={attr.value}
                    onChange={(e) => {
                      const newAttrs = [...currentAttributes];
                      newAttrs[index] = {
                        ...newAttrs[index],
                        value: e.target.value
                      };
                      setValue("attributes", newAttrs, {
                        shouldDirty: true
                      });
                    }}
                    size="lg"
                    placeholder={t("placeholders.attributeValue")}
                    disabled={isPending}
                  />
                </div>
              </div>
            </div>
          );
        })}

        <div className="flex justify-end">
          <button
            type="button"
            className="text-noble-blue-500 flex gap-x-1 items-center bg-transparent border-none cursor-pointer whitespace-nowrap"
            onClick={() => {
              const newAttrs = [...currentAttributes, { key: "", value: "" }];
              setValue("attributes", newAttrs, { shouldDirty: true });
            }}
            disabled={isPending}
          >
            <span>{t("buttons.addAttribute")}</span>
            <MdAddCircleOutline className="h-5 w-5" />
          </button>
        </div>
      </div>
    </Input.Wrapper>
  );
};
